<template>
  <div
    v-if="data"
    class="basic_wrap"
  >
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div
        class="big_tit van-ellipsis"
        style="font-size: 12px;max-width: 70%;"
      >
        VIDEO
      </div>
      <div class="top_right" />
    </div>
    <div class="movie-content">
      <video
        ref="videoPlayer"
        class="video-js vjs-default-skin"
        webkit-playsinline="false"
        role="application"
        tabindex="-1"
        preload="auto"
        playsinline="playsinline"
        controls
        controlslist="nofullscreen"
        autoplay="autoplay"
        width="100%"
      />
      <div class="movie-descript">
        <!-- <p style="color: rgb(62, 33, 134);">
		            {{data.title}}
				</p> -->
        <span style="color: rgb(170, 45, 220); font-size: 12px; background: rgb(242, 242, 245); padding: 5px; border-radius: 8px;">
          {{ data.pnum }} {{ $t('sky.play') }}
        </span>
      </div>
      <div class="movie-body">
        <div class="movie-title">
          <div style="display: flex; align-items: center; width: 100%;">
            <div
              class="van-image"
              style="width: 30px; margin-right: 10px;"
            >
              <img
                src="../images/home/play.png"
                class="van-image__img"
              >
              <!-- <div class="van-image__error">
								<i class="van-icon van-icon-photo-fail van-image__error-icon"></i>
							</div> -->
            </div>
            <span style="color: rgb(75, 53, 139);">{{ $t('sky.retui') }}</span>
          </div>
        </div>
        <div
          v-if="list"
          class="hotlist"
        >
          <div
            v-for="item in list"
            :key="item.id"
            @click="tovideo(item.id)"
          >
            <img :src="item.pic">
            <div>
              <!-- <span>{{item.title}}</span> -->
              <span>{{ $t('sky.play') }}:{{ item.pnum }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showWatchTip"
      class="watch-mask"
    >
      <div class="watch-dialog">
        <div class="watch-title">
          <span>{{ $t('sky.watchVideoTitle') }}</span>
          <span
            class="watch-close"
            @click="closeshowtip()"
          >×</span>
        </div>
        <div class="watch-content">
          <!-- {{ $t('sky.watchVideoTrialTip') }} -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,List,Card,ShareSheet
	} from "vant";
	import videojs from "video.js";
	import "video.js/dist/video-js.css";
	import Fetch from "../../utils/fetch";
	Vue.use(Empty).use(List).use(Card).use(ShareSheet);
	export default {
		name: "Vplay",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				loading:false,
				page:1,
				list:null,
				player:null,
				adSkipSeconds:0,
				trialLimitSeconds: 1200,
				trialStartTime: 0,
				maxWatchedTime: 0,
				isResettingSeek: false,
				trialStopped: false,
				cur:0,
				area:null,
				arealist:null,
				locationsel: false,
				type:0,
				finished:false,
				empty: false,
				showWatchTip: false,
			};
		},
		created() {
			this.$parent.footer("video",true);
		},
		mounted() {
			// console.log(this.$router.history.current)
			this.initPlayer();
			this.start();
			// this.showWatchTip = true;
		},
		beforeDestroy() {
			if (this.player) {
				this.player.off("loadedmetadata", this.skipOpeningAd);
				this.player.off("timeupdate", this.limitTrialPlay);
				this.player.off("seeking", this.preventSeek);
				this.player.off("play", this.preventTrialReplay);
				this.player.dispose();
				this.player = null;
			}
		},
		beforeRouteUpdate(to, from, next) {
			next();
			this.showWatchTip = true;
			this.video(to.params.code);
		},
		methods: {
			closeshowtip(){
				this.showWatchTip= false;
				if(this.trialStopped){
					this.$router.push('/vindex' );
				}
			},
			initPlayer() {
				if (this.player || !this.$refs.videoPlayer) {
					return;
				}
				this.player = videojs(this.$refs.videoPlayer, {
					controls: true,
					autoplay: false,
					preload: "auto",
					fluid: true
				});
				this.player.on("loadedmetadata", this.skipOpeningAd);
				this.player.on("timeupdate", this.limitTrialPlay);
				this.player.on("seeking", this.preventSeek);
				this.player.on("play", this.preventTrialReplay);
			},
			setVideoSource(url) {
				if (!url) {
					return;
				}
				if (!this.player) {
					this.initPlayer();
				}
				const type = /\.m3u8($|\?)/i.test(url) ? "application/x-mpegURL" : "video/mp4";
				this.adSkipSeconds = 0;
				this.trialStartTime = 0;
				this.maxWatchedTime = 0;
				this.trialStopped = false;
				this.isResettingSeek = false;
				this.player.pause();
				this.player.src({
					src: url,
					type: type
				});
				this.loadAdSkipSeconds(url);
				this.player.load();
				const promise = this.player.play();
				if (promise && promise.catch) {
					promise.catch(() => {});
				}
			},
			loadAdSkipSeconds(url) {
				if (!/\.m3u8($|\?)/i.test(url)) {
					return;
				}
				this.getOpeningAdSeconds(url).then(seconds => {
					this.adSkipSeconds = seconds;
					this.trialStartTime = seconds || 0;
					this.maxWatchedTime = this.trialStartTime;
					this.skipOpeningAd();
				}).catch(() => {
					this.adSkipSeconds = 0;
					this.trialStartTime = 0;
					this.maxWatchedTime = 0;
				});
			},
			skipOpeningAd() {
				if (!this.player || !this.adSkipSeconds || this.player.currentTime() >= this.adSkipSeconds) {
					return;
				}
				this.isResettingSeek = true;
				this.maxWatchedTime = this.adSkipSeconds;
				this.player.currentTime(this.adSkipSeconds);
				setTimeout(() => {
					this.isResettingSeek = false;
				}, 100);
			},
			getTrialEndTime() {
				return this.trialStartTime + this.trialLimitSeconds;
			},
			limitTrialPlay() {
				if (!this.player) {
					return;
				}
				const currentTime = this.player.currentTime();
				const endTime = this.getTrialEndTime();
				if (currentTime > this.maxWatchedTime && currentTime <= endTime) {
					this.maxWatchedTime = currentTime;
				}
				if (currentTime >= endTime) {
					this.trialStopped = true;
					this.isResettingSeek = true;
					this.player.currentTime(endTime);
					this.player.pause();
					this.showWatchTip = true;
					setTimeout(() => {
						this.isResettingSeek = false;
					}, 100);
				}
			},
			preventSeek() {
				if (!this.player || this.isResettingSeek) {
					return;
				}
				const currentTime = this.player.currentTime();
				const endTime = this.getTrialEndTime();
				if (currentTime > this.maxWatchedTime + 0.8 || currentTime < this.trialStartTime - 0.5 || currentTime > endTime) {
					const safeTime = Math.min(Math.max(this.maxWatchedTime, this.trialStartTime), endTime);
					this.isResettingSeek = true;
					this.player.currentTime(safeTime);
					setTimeout(() => {
						this.isResettingSeek = false;
					}, 100);
				}
			},
			preventTrialReplay() {
				if (!this.player || !this.trialStopped) {
					return;
				}
				this.player.pause();
				this.player.currentTime(this.getTrialEndTime());
			},
			getOpeningAdSeconds(url) {
				return fetch(url, {
					cache: "no-cache"
				}).then(response => response.text()).then(text => {
					const mediaUrl = this.getMediaPlaylistUrl(url, text);
					if (!mediaUrl) {
						return text;
					}
					return fetch(mediaUrl, {
						cache: "no-cache"
					}).then(response => response.text());
				}).then(text => {
					return this.parseOpeningAdSeconds(text);
				});
			},
			getMediaPlaylistUrl(baseUrl, text) {
				const lines = text.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
				for (let i = 0; i < lines.length; i++) {
					if (lines[i].indexOf("#EXT-X-STREAM-INF") === 0) {
						for (let j = i + 1; j < lines.length; j++) {
							if (lines[j].indexOf("#") !== 0) {
								return this.toAbsoluteUrl(baseUrl, lines[j]);
							}
						}
					}
				}
				return null;
			},
			parseOpeningAdSeconds(text) {
				let seconds = 0;
				const lines = text.split(/\r?\n/);
				for (let i = 0; i < lines.length; i++) {
					const line = lines[i].trim();
					if (line.indexOf("#EXT-X-DISCONTINUITY") === 0) {
						return seconds > 0 && seconds <= 90 ? seconds : 0;
					}
					if (line.indexOf("#EXTINF:") === 0) {
						const value = parseFloat(line.replace("#EXTINF:", "").split(",")[0]);
						if (!isNaN(value)) {
							seconds += value;
						}
					}
				}
				return 0;
			},
			toAbsoluteUrl(baseUrl, path) {
				if (/^https?:\/\//i.test(path)) {
					return path;
				}
				const url = new URL(baseUrl);
				if (path.indexOf("/") === 0) {
					return url.origin + path;
				}
				return baseUrl.replace(/\/[^/]*$/, "/") + path;
			},
			tovideo(id) {
				this.$router.push('/vplay/' + id);
			},
			video(id) {
				if(this.player){
					this.player.pause();
				}
				Fetch('/user/video', {
					id: id
				}).then(res => {
					this.data = res.data.vedio;
					this.list = res.data.list;
					 // 获取 video 元素并重新加载
					this.$nextTick(() => {
						this.setVideoSource(this.data.url);
					});
				})
			},
			start() {
				this.video(this.$router.history.current.params.code);
			},
		},
	};
</script>

<style lang="less" scoped>
	
	.movie-content {
		flex: 1;
		overflow-y: auto;
		padding-bottom: 60px;
	}
	
	.movie-content .movie-descript {
		width: 100%;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		padding: 15px
	}
	
	.movie-content .movie-descript p {
	    font-size: 14px;
	    line-height: 20px;
	    font-weight: 700;
	}
	
	.movie-content .movie-descript span {
		color: #979799
	}
	
	.movie-content .movie-body {
		width: calc(100% - 20px);
		margin: 0 auto
	}
	
	 .movie-video .video-js .vjs-big-play-button {
		top: 50%;
		left: 50%;
		margin-top: -7vw;
		margin-left: -13vw
	}

	.video-js /deep/ .vjs-progress-control {
		display: none;
		pointer-events: none;
	}

	.video-js /deep/ .vjs-remaining-time,
	.video-js /deep/ .vjs-duration,
	.video-js /deep/ .vjs-current-time,
	.video-js /deep/ .vjs-time-divider {
		display: none;
	}
	
	.movie-content .movie-body .movie-title {
		height: 9vw;
		display: flex;
		align-items: center;
		justify-content: space-between
	}
	
	.movie-content .movie-body .movie-title>div:first-child {
		width: 27vw
	}
	
	.movie-content .movie-body .movie-title>div:first-child span {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 16px;
		font-weight: 700;
		color: #000
	}
	
	.movie-play-item {
		width: 100%;
		height: 170px;
		border-radius: 10px;
		position: relative;
		display: flex;
		background-color: #fff;
		margin-bottom: 20px
	}
	
	.movie-play-item>div {
		height: 100%
	}
	
	.movie-play-item>div:first-child {
		width: 27vw;
		position: relative
	}
	
	.movie-play-item>div:first-child>img {
		width: 100%;
		height: 100%;
		border-radius: 10px 0 0 10px
	}
	
	.movie-play-item>div:first-child>div {
		position: absolute;
		width: 100%;
		height: 16px;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 10px;
		background-color: rgba(0,0,0,.4);
		border-radius: 0 0 0 10px
	}
	
	.movie-play-item>div:first-child>div .van-count-down {
		color: #fff;
		font-size: 12px
	}
	
	.movie-play-item>div:nth-child(2) p {
		width: 67vw;
		height: 8vw;
		font-size: 4vw;
		line-height: 4vw;
		word-break: break-all;
		overflow: hidden;
		color: #000
	}
	
	.movie-play-item>div:nth-child(2) span {
	color: #000
	}
	
	.movie-play-item>div:nth-child(2) {
		padding: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between
	}
	.hotlist {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between
	}
	
	.hotlist>div {
		position: relative;
		width: calc(50% - 5px);
		border-radius: 8px;
		overflow: hidden;
		margin-bottom: 10px
	}
	
	.hotlist>div img {
		width: 100%;
		height: 170px
	}
	
	.hotlist>div>div {
		position: absolute;
		bottom: 0;
		width: 100%;
		left: 0;
		background: rgba(0,0,0,.4);
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 12px;
		height: 30px;
		border-radius: 8px
	}
	
	.hotlist>div>div span {
		width: 50%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
		padding-left: 10px
	}

	.watch-mask {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 2000;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.62);
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 10vw;
		box-sizing: border-box;
	}

	.watch-dialog {
		width: 100%;
		background: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
	}

	.watch-title {
		position: relative;
		height: 46px;
		line-height: 46px;
		text-align: center;
		background:#db49aa;
		color: #fff;
		font-size: 18px;
		font-weight: 700;
		font-family: Georgia, "Times New Roman", serif;
	}

	.watch-close {
		position: absolute;
		right: 18px;
		top: 0;
		font-size: 34px;
		line-height: 42px;
		font-weight: 300;
		color: #fff;
	}

	.watch-content {
		padding: 18px 20px 20px;
		color: #4d42ff;
		font-size: 15px;
		line-height: 22px;
		font-family: Georgia, "Times New Roman", serif;
		word-break: normal;
	}

	.basic_wrap {
		min-height: 100vh;
		box-sizing: border-box;
		padding: 12px 18px 78px;
		background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
	}

	.red_top_bg {
		height:50px;
		background: transparent;
	}

	.red_top_bg .big_tit {
		top: 5px;
		color: #111;
		font-size: 14px !important;
		line-height: 20px;
	}

	.red_top_bg .back_left {
		width: 24px;
		height: 24px;
		margin: 3px 0 0;
	}

	.movie-content {
		padding-bottom: 0;
	}

	.video-js {
		overflow: hidden;
		border-radius: 10px;
		background: #1f1a23;
	}

	.movie-content .movie-descript {
		width: auto;
		margin-top: 12px;
		padding: 12px 14px;
		border-radius: 10px;
		background: #fff;
	}

	.movie-content .movie-descript span {
		color: #f8328c !important;
		background: #fff3f8 !important;
		font-size: 12px !important;
	}

	.movie-content .movie-body {
		width: auto;
		margin-top: 12px;
		padding: 0 14px 14px;
		border-radius: 10px;
		background: #fff;
	}

	.movie-content .movie-body .movie-title {
		height: 42px;
	}

	.movie-content .movie-body .movie-title > div:first-child span {
		color: #2d2433 !important;
		font-size: 12px !important;
	}

	.hotlist {
		gap: 10px;
	}

	.hotlist > div {
		width: calc(50% - 5px);
		margin-bottom: 0;
		border-radius: 7px;
	}

	.hotlist > div img {
		height: auto;
		aspect-ratio: 1 / 1;
		object-fit: cover;
	}

	.hotlist > div > div {
		height: 22px;
		background: rgba(45, 36, 51, 0.72);
		font-size: 10px;
	}

	.watch-dialog {
		border-radius: 12px;
		overflow: hidden;
	}

	.watch-title {
		height: 42px;
		background: linear-gradient(100deg, #df4ab7 0%, #6d3bc4 100%);
		font-family: inherit;
		font-size: 14px;
		line-height: 42px;
	}

	.watch-content {
		padding: 14px;
		color: #5e5665;
		font-family: inherit;
		font-size: 12px;
		line-height: 18px;
	}
</style>
